import React, { useCallback } from 'react'
import styled, { css } from 'styled-components'
import { Add, Remove } from '@material-ui/icons'

interface Props {
  min?: number
  max?: number
  current: number
  onChange(nextValue: number): void
}

export default function Count({ min = 1, max = 999, current, onChange }: Props) {
  const disabledMinus = current <= min
  const disabledPlus = current >= max

  const handleClickMinus = useCallback(() => {
    if (disabledMinus) {
      return
    }
    onChange(current - 1)
  }, [current, disabledMinus])

  const handleClickPlus = useCallback(() => {
    if (disabledPlus) {
      return
    }
    onChange(current + 1)
  }, [current, disabledPlus])

  return (
    <Container>
      <IconButton disabled={disabledMinus} onClick={handleClickMinus}>
        <Remove style={{ fontSize: 24 }} />
      </IconButton>
      <Current>{current}</Current>
      <IconButton disabled={disabledPlus} onClick={handleClickPlus}>
        <Add style={{ fontSize: 24 }} />
      </IconButton>
    </Container>
  )
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
  justify-items: center;
  width: 128px;
`

const IconButton = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.OnSurface1};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.4;
    `}
`

const Current = styled.div`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
